import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IonInput } from '@ionic/angular';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chat-bot-card',
  templateUrl: './chat-bot-card.component.html',
  styleUrls: ['./chat-bot-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatBotCardComponent implements OnInit {
  @Input() dataChat = undefined;
  @Input() icon = undefined;
  @ViewChild('chatContainer') chatContainer: ElementRef<HTMLDivElement>;
  @ViewChild('inputResponse') inputResponse: IonInput;
  @Output() minimizeEmitter = new EventEmitter();

  public messages = [];

  private _talkId = undefined;
  private _end = false;
  public conversations = [];
  public typing = true;

  get end() {
    return this._end;
  }

  set end(value) {
    this._end = value;
  }

  constructor(
    private _httpSv: HttpService,
    private _cdr: ChangeDetectorRef,
    private _uiSv: UiServices
  ) {}

  ngOnInit() {
    this.startChat();
  }

  startChat(): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const res = await this._httpSv.itemAction(
          {
            domainId: environment.domainId,
          },
          'talk',
          'store'
        );
        const data = res.data;
        console.log('data :>> ', data);
        this._talkId = data.id;
        this.messages.push(data.suggestion);
        this.typing = false;
        this._cdr.detectChanges();
        resolve(true);
      }, 500);
    });
  }

  send(response: string | number = '', selectedOption?) {
    if (!selectedOption && !response) {
      return this._uiSv.presentAlert(
        'Verifica que el campo tenga un texto escrito antes de enviar.'
      );
    } else if (selectedOption) {
      const suggestion = this.messages.find(
        (x) => x.id === selectedOption?.suggestionId
      );
      suggestion.suggestionOption.forEach((x) => (x.disabled = true));
    }
    this.typing = true;
    if (response) {
      this.messages.push({
        name: response,
        type: 'me',
      });
      this.inputResponse.value = '';
    }
    this._cdr.detectChanges();
    this.scrollToBottom();
    setTimeout(async () => {
      const suggestion =
        this.messages.length -
        1 -
        this.messages
          .slice()
          .reverse()
          .findIndex((o) => o.type !== 'me');

      if (suggestion != -1) {
        const res = await this._httpSv.itemAction(
          {
            response,
            talkId: this._talkId,
            suggestionId:
              selectedOption?.suggestionId || this.messages[suggestion].id,
            domainId: environment.domainId,
            optionId: selectedOption?.id,
          },
          'talkSelected',
          'store'
        );
        const resSuggestion = res.data.suggestion;
        if (resSuggestion) {
          this.messages.push(resSuggestion);
          this._end = resSuggestion?.type !== 2 ? false : true;
        } else {
          this._end = true;
        }

        response = '';
        this.typing = false;
        this._cdr.detectChanges();
        setTimeout(() => {
          this.scrollToBottom();
        }, 100);
      }
    }, 500);
  }

  scrollToBottom() {
    this.chatContainer.nativeElement.scrollTo(
      0,
      this.chatContainer.nativeElement.scrollHeight
    );
  }

  async reset(pressingClose?) {
    if (pressingClose) {
      this.minimizeEmitter.emit();
    }
    this.messages = [];
    this._end = false;
    await this._uiSv.showLoading();
    await this.startChat();
    await this._uiSv.loading.dismiss();
  }
}
